<template>
	<button class="icon-menu-btn" :aria-label="open ? 'Close menu' : 'Open menu'" tabindex="-1" type="button">
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect class="bar bar1" :class="{ open }" x="0" y="5" width="28" height="3" rx="1.5" />
			<rect class="bar bar2" :class="{ open }" x="0" y="12.5" width="28" height="3" rx="1.5" />
			<rect class="bar bar3" :class="{ open }" x="0" y="20" width="28" height="3" rx="1.5" />
		</svg>
	</button>
</template>

<script setup lang="ts">
	import { toRef } from "vue"
	const props = defineProps<{ open?: boolean }>()
	const open = toRef(props, "open")
</script>

<style scoped>
	.icon-menu-btn {
		background: none;
		border: none;
		padding: 0;
		margin: 0;
		display: flex;
		align-items: center;
		cursor: pointer;
	}
	svg {
		display: block;
	}
	.bar {
		fill: currentColor;
		transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	}
	.bar1 {
		transform-origin: 14px 6.5px;
	}
	.bar2 {
		transform-origin: 14px 14px;
	}
	.bar3 {
		transform-origin: 14px 21.5px;
	}
	.bar1.open {
		transform: rotate(45deg) translate(5px, 5px);
	}
	.bar2.open {
		opacity: 0;
		transform: scaleX(0.5);
	}
	.bar3.open {
		transform: rotate(-45deg) translate(5px, -5px);
	}
</style>
